export default function ReportCard({ title, idTitle = "", justTitle = "",  value, children, className = "" }) {
    return (
        <div className="m-1">
            <div className={`text-center ${idTitle ? "cursor-pointer" : ""}`} title={idTitle || justTitle}>
                <div className={`box ${className}`}>
                    <h3>{title}</h3>
                    {children && (
                        <>
                            {children}
                        </>
                    )}
                    <h2>{value}</h2>
                </div>
            </div>
        </div>
    )
}